import React from 'react';
import { FormattedMessage } from 'react-intl-next';
export var toAction = function toAction(action, invokeClientAction, message, id) {
  return {
    id: id,
    text: /*#__PURE__*/React.createElement(FormattedMessage, message),
    invoke: function invoke() {
      return invokeClientAction(action);
    }
  };
};